"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MagicLinkIntentEnum = void 0;
var MagicLinkIntentEnum;
(function (MagicLinkIntentEnum) {
    MagicLinkIntentEnum["Login"] = "login";
    MagicLinkIntentEnum["SignUp"] = "signUp";
})(MagicLinkIntentEnum = exports.MagicLinkIntentEnum || (exports.MagicLinkIntentEnum = {}));
//# sourceMappingURL=magic-link-intent-enum.js.map